import { useEffect } from 'react'
import { useFilter } from '../../features/filter/hook'
import { AggregateWindow } from '../../features/filter/types/types'

/**
 * On mount, force the global filter to a default date range + aggregation window.
 * Used by LuminaireDashboardPage and MinigridLiveEnergyDashboardPage.
 */
export function useDefaultFilter(days: number = 7, aggregateWindow: AggregateWindow = '1h') {
  const { filter, setFilter } = useFilter()

  useEffect(() => {
    const stop = new Date()
    const start = new Date()
    start.setUTCDate(start.getUTCDate() - days)
    setFilter({
      ...filter,
      startDate: start.toISOString(),
      stopDate: stop.toISOString(),
      aggregateWindow,
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return { filter, setFilter }
}
